import React, { FC } from 'react';
import { Field, Select } from '@kontentino/ui';
import { CTA_DATA } from '@kontentino/kontentino-constants/FacebookCTA';

const CTAS = Object.entries(CTA_DATA as Record<number, string>);

const options = CTAS.map(([value, label]) => ({
  value,
  label,
}));

type Props = {
  value: number | null;
  onChange(value: number | null): void;
  disabled?: boolean;
};

const CallToActionSelect: FC<Props> = (props) => {
  function getValue() {
    const stringValue = `${props.value}`;

    if (props.value) {
      const label = CTAS.find(([value]) => value === stringValue)?.[1];

      if (label) {
        return {
          value: stringValue,
          label: label,
        };
      }
    }

    return null;
  }

  return (
    <Field.Group>
      <Field.Label required>Call to action</Field.Label>
      <Select
        isClearable
        options={options}
        value={getValue()}
        onChange={(newValue) => props.onChange(Number(newValue?.value) || null)}
        isDisabled={props.disabled}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (styles) => ({
            ...styles,
            zIndex: 1010,
          }),
        }}
      />
    </Field.Group>
  );
};

export default CallToActionSelect;
